export default __webpack_public_path__ + "static/media/firefox_icon.c50c6709.png";